import { dashboardCookieName } from './dashboard-cookie-name'

export const showNewDashboard = (
  $q: {
    readonly resolve: angular.IQService['resolve']
  },
  $cookies: {
    readonly get: LegacyCookiesService['get']
  }
) => $q.resolve(!!$cookies.get(dashboardCookieName))

export const dashboardConfig = (
  $routeSegmentProvider: {
    readonly segment: LegacyRouteSegmentProvider['segment']
    readonly when: LegacyRouteSegmentProvider['when']
  },
  AuthOptionsProvider: {
    readonly buildSecureRouteConfigurationWithController: LegacyAuthOptionsProvider['buildSecureRouteConfigurationWithController']
  }
) => {
  'ngInject'

  $routeSegmentProvider.segment(
    'dashboard',
    AuthOptionsProvider.buildSecureRouteConfigurationWithController(
      'views/dashboard-switch.html',
      'DashboardSwitchCtrl',
      false,
      ['orgUuid'],
      {
        showNewDashboard
      }
    )
  )

  $routeSegmentProvider.when('/:orgUuid/dashboard', 'dashboard')
}
